import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FileSelector from '../file_selector';
import LoadingSpinner from "components/loading_spinner";
import RecordsTable from '../records_table/records_table';
import ImportSummary from './import_summary';

import { retrieveRunRecords } from '../store/actions/run_records';

export class Review extends React.Component {
  static propTypes = {
    files: PropTypes.object.isRequired,
    importsListPath: PropTypes.string.isRequired,
    importStatus: PropTypes.number,
    loadingRecords: PropTypes.bool.isRequired,
    retrieveRunRecords: PropTypes.func.isRequired,
    selectedFileId: PropTypes.number.isRequired
  }

  componentDidMount() {
    const { retrieveRunRecords } = this.props;
    retrieveRunRecords(1);
  }

  calculateRevertedCount()  {
    const { files } = this.props;

    const totalFileCount = Object.values(files).length;
    let revertedFileCount = 0;
    let revertedCount = 0;

    Object.values(files).forEach((f) => {
      revertedCount += f.revertedCount;
      if (f.reverted) {
        revertedFileCount++;
      }
    });

    return [totalFileCount, revertedFileCount, revertedCount];
  }


  render() {
    return (
      <div className="container step-container review">
        {this.renderReview()}
      </div>
    );
  }

  renderReviewHeader() {
    return (
      <div className="mb-4">
        <h2 className="semibold mt-0">Review</h2>
        <div className="larger-text">
          Preview and verify the data from each of your CSVs below.
          This is what your data will look like once imported into Buildout.
          If there are any errors, formatting changes, or other changes you need
          to make to your data, you can edit the individual table cell and make the change.
        </div>
      </div>
    );
  }

  renderFileRevertedHeader(totalFileCount, revertedFileCount) {
    return (
      <div className="mb-4">
        <h2 className="semibold mt-0">File Reverted</h2>
        <div className="larger-text">
          {revertedFileCount} of {totalFileCount} Files were successfully reverted. Review the results below
        </div>
      </div>
    );
  }

  renderImportRevertedHeader(totalFileCount, revertedCount) {
    return (
      <div className="mb-4">
        <h2 className="semibold mt-0">Import Reverted</h2>
        <div className="larger-text">
          {totalFileCount} Files with {revertedCount} Records were reverted. Review the results below.
        </div>
      </div>
    );
  }

  renderRevertedHeader() {
    const [totalFileCount, revertedFileCount, revertedCount] = this.calculateRevertedCount();

    if (revertedFileCount === totalFileCount) {
      return this.renderImportRevertedHeader(totalFileCount, revertedCount);
    } else {
      return this.renderFileRevertedHeader(totalFileCount, revertedFileCount);
    }
  }

  renderReviewRecords() {
    const { loadingRecords } = this.props;

    if (loadingRecords) {
      return <LoadingSpinner />;
    } else {
      return (
        <React.Fragment>
          <ImportSummary />
          <div>
            <div className="h4 bold mt-5">Import Details</div>
            <RecordsTable />
          </div>
        </React.Fragment>
      );
    }
  }

  renderReview() {
    const { files, importsListPath, selectedFileId } = this.props;
    const file = files[selectedFileId];

    return (
      <React.Fragment>
        {file.reverted ? this.renderRevertedHeader() : this.renderReviewHeader()}
        <FileSelector />
        {this.renderReviewRecords()}
        <div className="mt-3">
          <a className="btn btn-save" href={importsListPath}>
            Back to Imports List
          </a>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  files: state.importObject.files,
  importsListPath: state.paths.importsListPath,
  importStatus: state.ui.importStatus,
  loadingRecords: state.runRecords.loadingRecords,
  selectedFileId: state.ui.selectedFileId
});

const mapDispatchToProps = {
  retrieveRunRecords
};

export default connect(mapStateToProps, mapDispatchToProps)(Review);